export default "__VITE_ASSET__CeZCTh$T__"